<template>
  <component :is="currentCookiePolicyComponent" />
</template>

<script>
import CookiePolicyGold from './cookiePolicy/cookiePolicyGold.vue'
import CookiePolicyTiger from './cookiePolicy/cookiePolicyTiger.vue'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    CookiePolicyGold,
    CookiePolicyTiger
  },
  mixins: [themeMixin],
  computed: {
    currentCookiePolicyComponent() {
      switch (this.currentTheme) {
        case 'theme_tiger':
          return 'CookiePolicyTiger'
        case 'theme_gold':
        default:
          return 'CookiePolicyGold'
      }
    }
  }
}
</script>
